export default __webpack_public_path__ + "static/cases-43b742a7db8912d50cab82dbf4cd06b3.png";